@if (showMenuSizeToggle) {
  <button
    class="toggle-menu-btn absolute rounded-full bg-white max-h-[24px] shadow right-[-12px] top-[76px] hover:bg-ui-green-light text-white active: bg-ui-primary"
    (click)="toggleMenu()"
  >
    <mat-icon class="text-ui-primary hover:text-white active:text-white">
      {{ !layout.menuShrunk() ? 'chevron_left' : 'chevron_right' }}
    </mat-icon>
  </button>
}
<div
  class="menu-contentainer select-none pt-2"
  [class.shrunk]="layout.menuShrunk()"
>
  <div class="logo-container">
    <a
      class="relative w-full h-full flex justify-center items-center"
      routerLink="/dashboard"
    >
      <div class="absolute inset-0 flex justify-center items-center">
        <img
          class="pt-2 pb-4 max-w-full h-auto object-contain logo-fade logo-big"
          alt="logo"
          src="assets/logo.png"
        />
      </div>
      <div class="absolute inset-0 flex justify-center items-center">
        <img
          class="pt-2 pb-4 max-w-full h-auto object-contain logo-fade logo-small"
          alt="logo"
          src="assets/logo_Sidebar_solid.svg"
        />
      </div>
    </a>
  </div>

  <avs-instance-badge
    class="mb-4 transition-all duration-300 instance-badge"
    [minified]="!layout.menuShrunk()"
  />

  <mat-nav-list class="main-menu flex py-0 flex-col flex-grow">
    @if (clientsList.length && (isSuperAdmin$ | async)) {
      <div class="px-4">
        <div
          class="select-client-button relative"
          (tpVisible)="resetSearch()"
          [tp]="tpl"
          [tpPlacement]="!layout.menuShrunk() ? 'bottom' : 'right-start'"
          tpTrigger="click"
          tpVariation="popper"
        >
          <div class="grid place-items-center w-full h-full">
          <span class="whitespace-nowrap overflow-hidden logo-fade col-start-1 row-start-1 logo-small">
            {{ selectedClient()?.friendlyName?.charAt(0) }}
          </span>
            <span class="whitespace-nowrap overflow-hidden text-ellipsis max-w-[140px] logo-fade col-start-1 row-start-1 logo-big">
              {{ selectedClient()?.friendlyName }}
            </span>
          </div>
          <mat-icon class="arrow-down absolute right-2">keyboard_arrow_down</mat-icon>
        </div>
      </div>
    }

    <avs-li-dashboards-selector />

    <a
      class="test-menu-item menu-item mr-2 ml-2 pr-2 w-auto relative"
      [matTooltipDisabled]="!layout.menuShrunk()"
      #devices="routerLinkActive"
      mat-list-item
      matTooltip="Devices"
      matTooltipPosition="right"
      routerLink="devices"
      routerLinkActive="main-menu-item-active"
    >
      <mat-label class="text-white flex align-middle relative">
        <i
          class="text-white ml-2 mr-4 text-3xl"
          [ngClass]="devices.isActive ? 'icon-devices' : 'icon-devices-stroke'"
          matPrefix
        ></i>
        <span class="text-sm in-out-animation">
          Devices
        </span>
      </mat-label>
    </a>

    <a
      class="test-menu-item menu-item mr-2 ml-2 pr-2 w-auto relative"
      [matTooltipDisabled]="!layout.menuShrunk()"
      #incidents="routerLinkActive"
      mat-list-item
      matTooltip="Incidents"
      matTooltipPosition="right"
      routerLink="incidents"
      routerLinkActive="main-menu-item-active"
    >
      <mat-label class="text-white flex align-middle relative">
        <i
          class="text-white ml-2 mr-4 text-3xl"
          [ngClass]="incidents.isActive ? 'icon-incidents' : 'icon-incidents-stroke'"
          matPrefix
        ></i>
        <span class="text-sm in-out-animation">
          Incidents
        </span>
      </mat-label>
      @if (incidentsCount$ | async; as incidentsCount) {
        <div class="absolute right-3 top-2 flex items-center justify-center w-8 h-8 pointer-events-none">
          <span class="incidents-amount-indicator absolute logo-fade logo-big">
            {{ incidentsCount > 99 ? '99+' : incidentsCount }}
          </span>
          <span class="absolute h-2 w-2 rounded-full bg-ui-red-100 left-7 top-0.5 logo-fade logo-small"></span>
        </div>
      }
    </a>
    <a
      class="test-menu-item menu-item mr-2 ml-2 pr-2 w-auto relative"
      [matTooltipDisabled]="!layout.menuShrunk()"
      #reporting="routerLinkActive"
      mat-list-item
      matTooltip="Reporting"
      matTooltipPosition="right"
      routerLink="reporting"
      routerLinkActive="main-menu-item-active"
    >
      <mat-label class="text-white flex align-middle relative">
        <i
          class="text-white ml-2 mr-4 text-3xl"
          [ngClass]="reporting.isActive ? 'icon-reporting' : 'icon-reporting-stroke'"
          matPrefix
        ></i>
        <span class="text-sm in-out-animation">
          Reporting
        </span>
      </mat-label>
    </a>

    @if (!ucMonitoring.isDisabled()) {
      <a
        class="test-menu-item menu-item mr-2 ml-2 pr-2 w-auto relative"
        [matTooltipDisabled]="!layout.menuShrunk()"
        #callQuality="routerLinkActive"
        mat-list-item
        matTooltip="UC Monitoring"
        matTooltipPosition="right"
        routerLink="call-quality"
        routerLinkActive="main-menu-item-active"
      >
        <mat-label class="text-white flex align-middle relative">
          <mat-icon
            class="text-white ml-2 mr-4 shrink-0"
            [ngClass]="callQuality.isActive ? 'material-icons' : 'material-icons-outlined'"
            matPrefix
          >
            phone_in_talk
          </mat-icon>
          <span class="text-sm in-out-animation">
            UC Monitoring
          </span>
        </mat-label>
      </a>
    }

    <a
      class="test-menu-item menu-item mr-2 ml-2 pr-2 w-auto relative"
      [matTooltipDisabled]="!layout.menuShrunk()"
      [showForClientAdmin]="true"
      #alertSettings="routerLinkActive"
      avsRestrictedEl
      mat-list-item
      matTooltip="Alert Settings"
      matTooltipPosition="right"
      routerLink="alert-settings"
      routerLinkActive="main-menu-item-active"
    >
      <mat-label class="text-white flex align-middle relative">
        <i
          class="text-white ml-2 mr-4 text-3xl"
          [ngClass]="alertSettings.isActive ? 'icon-menu-alert' : 'icon-menu-alert-stroke'"
          matPrefix
        ></i>
        <span class="text-sm in-out-animation">
          Alert Settings
        </span>
      </mat-label>
    </a>

    <a
      class="test-menu-item menu-item mr-2 ml-2 pr-2 w-auto relative"
      [matTooltipDisabled]="!layout.menuShrunk()"
      #userManagement="routerLinkActive"
      mat-list-item
      matTooltip="User Management"
      matTooltipPosition="right"
      routerLink="user-management"
      routerLinkActive="main-menu-item-active"
    >
      <mat-label class="text-white flex align-middle relative">
        <i
          class="text-white ml-2 mr-4 text-3xl"
          [ngClass]="userManagement.isActive ? 'icon-users-management' : 'icon-users-management-stroke'"
          matPrefix
        ></i>
        <span class="text-sm in-out-animation">
          User Management
        </span>
      </mat-label>
    </a>

    <a
      class="test-menu-item menu-item mr-2 ml-2 pr-2 w-auto relative"
      [matTooltipDisabled]="!layout.menuShrunk()"
      [showForClientAdmin]="true"
      #settings="routerLinkActive"
      avsRestrictedEl
      mat-list-item
      matTooltip="Settings"
      matTooltipPosition="right"
      routerLink="settings"
      routerLinkActive="main-menu-item-active"
    >
      <mat-label class="text-white flex align-middle relative">
        <i
          class="text-white ml-2 mr-4 text-3xl"
          [ngClass]="settings.isActive ? 'icon-settings' : 'icon-settings-stroke'"
          matPrefix
        ></i>
        <span class="text-sm in-out-animation">
          Settings
        </span>
      </mat-label>
    </a>

    <div
      class="my-6 border-t border-ui-green-300"
      avsRestrictedEl
    ></div>

    @if ('inventory' | avsFeatureFlag) {
      <a
        class="test-menu-item menu-item mr-2 ml-2 pr-2 w-auto relative"
        [matTooltipDisabled]="!layout.menuShrunk()"
        #inventory="routerLinkActive"
        avsRestrictedEl
        mat-list-item
        matTooltip="Inventory"
        matTooltipPosition="right"
        routerLink="inventory"
        routerLinkActive="main-menu-item-active"
      >
        <mat-label class="text-white flex align-middle relative">
          <i
            class="text-white ml-2 mr-4 text-3xl"
            [ngClass]="inventory.isActive ? 'icon-inventory' : 'icon-inventory-stroke'"
            matPrefix
          ></i>
          <span class="text-sm in-out-animation">
            Inventory
          </span>
        </mat-label>
      </a>
    }

    <a
      class="test-menu-item menu-item mr-2 ml-2 pr-2 w-auto relative"
      [matTooltipDisabled]="!layout.menuShrunk()"
      #deviceManagement="routerLinkActive"
      avsRestrictedEl
      mat-list-item
      matTooltip="Device Management"
      matTooltipPosition="right"
      routerLink="device-management"
      routerLinkActive="main-menu-item-active"
    >
      <mat-label class="text-white flex align-middle relative">
        <i
          class="text-white ml-2 mr-4 text-3xl"
          [ngClass]="deviceManagement.isActive ? 'icon-device-management' : 'icon-device-management-stroke'"
          matPrefix
        ></i>
        <span class="text-sm in-out-animation">
          Device Management
        </span>
      </mat-label>
    </a>

    <a
      class="test-menu-item menu-item mr-2 ml-2 pr-2 w-auto"
      [matTooltipDisabled]="!layout.menuShrunk()"
      #clientManagement="routerLinkActive"
      avsRestrictedEl
      mat-list-item
      matTooltip="Client Management"
      matTooltipPosition="right"
      routerLink="client-management"
      routerLinkActive="main-menu-item-active"
    >
      <mat-label class="text-white flex align-middle">
        <i
          class="text-white ml-2 mr-4 text-3xl"
          [ngClass]="clientManagement.isActive ? 'icon-star' : 'icon-star-stroke'"
          matPrefix
        ></i>
        <span class="text-sm in-out-animation">
          Client Management
        </span>
      </mat-label>
    </a>

    <a
      class="test-menu-item menu-item mr-2 ml-2 pr-2 w-auto relative"
      [matTooltipDisabled]="!layout.menuShrunk()"
      #MQTTUsers="routerLinkActive"
      avsRestrictedEl
      mat-list-item
      matTooltip="MQTT Users"
      matTooltipPosition="right"
      routerLink="mqtt-users"
      routerLinkActive="main-menu-item-active"
    >
      <mat-label class="text-white flex align-middle relative">
        <i
          class="text-white ml-2 mr-4 text-3xl"
          [ngClass]="MQTTUsers.isActive ? 'icon-ic_cloud_fill' : 'icon-ic_cloud_stroke'"
          matPrefix
        ></i>
        <span class="text-sm in-out-animation">
          MQTT Users
        </span>
      </mat-label>
    </a>
    <a
      class="test-menu-item menu-item mr-2 ml-2 pr-2 w-auto"
      [matTooltipDisabled]="!layout.menuShrunk()"
      #myProfile="routerLinkActive"
      mat-list-item
      matTooltip="My Profile"
      matTooltipPosition="right"
      routerLink="user-profile"
      routerLinkActive="main-menu-item-active"
    >
      <mat-label class="text-white flex align-middle">
        <i
          class="text-white ml-2 mr-4 text-3xl"
          [ngClass]="myProfile.isActive ? 'icon-my-profile' : 'icon-my-profile-stroke'"
          matPrefix
        ></i>
        <span class="text-sm in-out-animation">
          My Profile
        </span>
      </mat-label>
    </a>
    <a
      class="test-logout-menu-item menu-item mr-2 ml-2 pr-2 w-auto mb-6 mt-auto"
      (click)="logout()"
      [matTooltipDisabled]="!layout.menuShrunk()"
      mat-list-item
      matTooltip="Log Out"
      matTooltipPosition="right"
    >
      <mat-label class="text-white flex align-middle">
        <i
          class="text-white ml-2 mr-4 text-2xl icon-log-out"
          matPrefix
        ></i>
        <span class="text-sm in-out-animation">
          Log Out
        </span>
      </mat-label>
    </a>

  </mat-nav-list>
</div>

<ng-template
  #tpl
  let-hide
>
  <div class="w-[200px] py-2 test-client-list">
    <div class="mx-0.5">
      <app-search-input
        (searchDataEvent)="clientSearch($event)"
        cssClass="no-border"
        inputWidth="100%"
        placeholder="Enter name"
      ></app-search-input>
    </div>
    <div>
      <ul class="max-h-[320px] overflow-y-auto">
        @for (client of clientsList | sort : 'asc' : 'friendlyName' | filterClientsByName : clientSearchValue; track client) {
          <li
            class="h-10 text-black text-sm flex items-center hover:bg-ui-green-150 px-3 cursor-pointer whitespace-nowrap"
            (click)="clientChange(client); hide()"
            [class.text-ui-green-light]="client.id === selectedClient()?.id"
            [matTooltip]="client.friendlyName"
            matTooltipPosition="right"
          >
            <span class="text-ellipsis overflow-hidden">{{ client.friendlyName }}</span>
          </li>
        }
        @if (!clientsList.length) {
          <li class="flex justify-center text-ui-gray-100">
            No Results
          </li>
        }
      </ul>
    </div>
  </div>
</ng-template>
